import { render, staticRenderFns } from "./CardAccessoryLight.vue?vue&type=template&id=bcdbc7a0"
import script from "./CardAccessoryLight.vue?vue&type=script&lang=js"
export * from "./CardAccessoryLight.vue?vue&type=script&lang=js"
import style0 from "./CardAccessoryLight.vue?vue&type=style&index=0&id=bcdbc7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports